import { useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  getPositionIds,
  removeLiquiditynew,
} from "../uniswap/position";
import { NavLink } from "react-router-dom";
import {
  XBR,
  USDT,
  LightmodeUSDT,
  LightmodeXBR,
  USDTimg,
  XBRimg,
  tba,
} from "../assets";
import { getLiquidity } from "../uniswap/liquidity.js";
import LiquidityConfirmationModal from "./LiquidityConfirmationModal";
import LiquidityConfirmedModal from "./LiquidityConfirmedModal";
import { BiLoaderAlt } from "react-icons/bi";
import { useRef } from "react";
import tabBgVideo from "../assets/SwapbgVideo.mp4";
import { MdClose } from "react-icons/md";
import FailedTransaction from "./FailedTransaction.jsx";
import { useContextProvider } from '../context/index.jsx';

const RemoveLiquidity = (props) => {
  const theme = useTheme();
  const [positionIds, setPositionIds] = useState([]);
  const { nftId, onClose, setIsLiquidityChanged, setRemoveLiquidity } = props;
	const {walletAddress, jsonRpcProvider}= useContextProvider();

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(nftId);
  const dropdownRef = useRef(null);
  const [removeLiquidityValue, setRemoveLiquidityValue] = useState(0);
  const [removeToken0Liquidity, setRemoveToken0Liquidity] = useState(0);
  const [removeToken1Liquidity, setRemoveToken1Liquidity] = useState(0);
  const [token0LiquidityAmount, setToken0LiquidityAmount] = useState("0.00");
  const [token1LiquidityAmount, setToken1LiquidityAmount] = useState("0.00");
  const [token0Address, setToken0Address] = useState("");
  const [token1Address, setToken1Address] = useState("");
  const [token0Name, setToken0Name] = useState("USDT");
  const [token1Name, setToken1Name] = useState("XBR");
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isRemoveConfirmed, setIsRemoveConfirmed] = useState(false);
  const [isTransactionFailed, setIsTransactionFailed] = useState(false);
  const [error, setError] = useState(false);
  const [hashdata, setHashdata] = useState("");
  const tokenImageMap = {
    XBR: XBRimg,
    USDT: USDTimg,
    TBA: tba,
  };
  const trackStyle =
    theme.palette.mode === "light"
      ? {
          background: `linear-gradient(to right, #5663F2 ${removeLiquidityValue}%, #EEEFFE ${removeLiquidityValue}%)`,
        }
      : {
          background: `#302E47`,
        };

  const calculateRemoveLiquidity = (balance) => {
    return (balance * removeLiquidityValue) / 100;
  };

  const formatBalanceForPrice = (balance) => {
    const num = parseFloat(balance);
    if (num >= 1e12) {
      return (num / 1e12).toFixed(1).replace(/\.0$/, "") + "T";
    } else if (num >= 1e9) {
      return (num / 1e9).toFixed(1).replace(/\.0$/, "") + "B";
    } else if (num >= 1e6) {
      return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (num >= 1e3) {
      return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "K";
    } else {
      return num.toFixed(6).replace(/\.?0+$/, "");
    }
  };

  useEffect(() => {
    const fetchPositionIds = async () => {
      try {
        const positions = await getPositionIds(walletAddress, jsonRpcProvider);
        setPositionIds(positions);
      } catch (error) {
        console.error("Error fetching positionIds:", error);
      }
    };
		if (walletAddress && jsonRpcProvider) fetchPositionIds();
  }, [walletAddress]);

  useEffect(() => {
    setRemoveToken0Liquidity(calculateRemoveLiquidity(token0LiquidityAmount));
    setRemoveToken1Liquidity(calculateRemoveLiquidity(token1LiquidityAmount));
  }, [removeLiquidityValue, positionIds]);

  useEffect(() => {
    const getLiquidityDataforid = async (jsonRpcProvider) => {
      const { token0, token1, fee } = await getLiquidity(
        Number(nftId),
        jsonRpcProvider
      );
      setToken0LiquidityAmount(token0?.amount);
      setToken1LiquidityAmount(token1?.amount);
      setToken0Name(token0?.symbol);
      setToken1Name(token1?.symbol);
      setToken0Address(token0?.address);
      setToken1Address(token1?.address);
    };
		jsonRpcProvider && getLiquidityDataforid(jsonRpcProvider);
  }, [jsonRpcProvider]);

  const handlePercentageButtonClick = (percentage) => {
    setRemoveLiquidityValue(percentage);
    setRemoveToken0Liquidity(calculateRemoveLiquidity(token0LiquidityAmount));
    setRemoveToken1Liquidity(calculateRemoveLiquidity(token1LiquidityAmount));
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    if (isDropdownOpen) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <div
      className={`flex  ${
        theme.palette.mode === "light" ? "bg-[#fff]" : "bg-darkCardBg"
      } flex-col justify-center items-center gap-4 fixed top-1/2 
      left-1/2 -translate-x-1/2 -translate-y-1/2 w-[96%] xs:w-[28.5rem] 
      p-2 xs:p-4 z-30 mobile:rounded-xl rounded-3xl`}
    >
      <div
        className={`text-[20px]  font-bold leading-[150%] ${
          theme.palette.mode === "light" ? "text-[#181821]" : "text-[#DCDCDE]"
        }`}
      >
        Remove Liquidity
      </div>
      <MdClose
        className="w-6 h-6 absolute top-3 right-2 xs:top-5 xs:right-4 font-bold cursor-pointer"
        onClick={onClose}
      />
      {selectedOption && (
        <div
          className={`rounded-2.5 mobile:rounded-2.5 flex-row items-center p-4 z-20 w-full ${
            theme.palette.mode === "light"
              ? "bg-white text-[#69696F]"
              : " text-[#97979B]"
          }`}
        >
          <div className={`flex justify-between  h-[24px]`}>
            <span
              className={`text-base ${
                theme.palette.mode === "light"
                  ? "text-[#181821]"
                  : " text-[#97979B]"
              }`}
            >
              {selectedOption}
            </span>
          </div>
          <div className={`flex justify-between w-full`}>
            <div
              className={`flex flex-shrink-0 p-2 pr-4 items-center rounded-[8px] ${
                theme.palette.mode === "light"
                  ? "bg-[#EEEFFE] text-[#181821]"
                  : "bg-darkButBg text-[#97979B]"
              }`}
            >
              <div className="flex justify-center items-center gap-1">
                <div className="flex items-center">
                  <img
                    src={tokenImageMap[token0Name]}
                    alt={token0Name}
                    className="w-7 h-7 border-2 border-[#21246A] rounded-[24px]"
                  />
                  <img
                    src={tokenImageMap[token1Name]}
                    alt={token1Name}
                    className="w-[29px] h-[29px] border-2 border-[#21246A] rounded-[24px] -ml-[10px]"
                  />
                </div>
                <span className={`text-base font-semibold inline-block`}>
                  {token0Name} / {token1Name}
                </span>
              </div>
            </div>
            <div className="flex flex-col items-end justify-center gap-1 text-right w-1/2">
              <input
                className={`
            relative bg-[transparent] text-right ${
              theme.palette.mode === "light"
                ? "text-mediumslateblue-600 bg-transparent placeholder:text-mediumslateblue-600"
                : "text-white"
            } 
            outline-none font-inter text-[31px] w-30 md:w-80per font-bold placeholder-white 
          `}
                placeholder="0.00"
                type="text"
                onWheel={(e) => e.preventDefault()}
                value={`${removeLiquidityValue}%`}
                readOnly
              />
            </div>
          </div>
          <div className={`flex justify-between invisible opacity-0`}>
            <div
              className={`text-base leading-6 mt-[2px] ${
                theme.palette.mode === "light"
                  ? "text-[#69696F]"
                  : "text-[#97979B]"
              } text-ft5`}
            >
              Balance: $2024.80
            </div>
            <div
              className={`text-base leading-6 ${
                theme.palette.mode === "light"
                  ? "text-[#69696F]"
                  : "text-[#97979B]"
              } text-ft5`}
            >
              ≈ $2024.80
            </div>
          </div>

          {selectedOption && (
            <div className="mt-4 z-10 w-full">
              <input
                type="range"
                min="0"
                max="100"
                step="5"
                value={removeLiquidityValue}
                className={`custom-slider mt-6 mb-10`}
                style={trackStyle}
                onChange={(e) =>
                  setRemoveLiquidityValue(parseFloat(e.target.value))
                }
              />
              <div className="flex gap-1 sm:gap-2 w-full items-center justify-between">
                {[25, 50, 75, 100].map((percentage) => (
                  <button
                    key={percentage}
                    className={`py-1 px-6 sm:px-7 rounded-[24px] text-center hover:cursor-pointer text-base mobile:text-[14px]  
                  ${
                    removeLiquidityValue === percentage
                      ? theme.palette.mode === "light"
                        ? "bg-[#5663F2] text-white"
                        : "bg-[#21246A] text-[#DCDCDE] border-2 border-[#21246A]"
                      : theme.palette.mode === "light"
                      ? "bg-transparent border-2 border-[#D6DAFC] text-[#181821]"
                      : "bg-transparent border-2 border-[#21246A] text-[#E6E7FD]"
                  }`}
                    onClick={() => handlePercentageButtonClick(percentage)}
                  >
                    {percentage === 100 ? "Max" : `${percentage}%`}
                  </button>
                ))}
              </div>
            </div>
          )}
          {walletAddress && selectedOption && (
            <div className="pt-6 flex flex-col gap-2 font-medium">
              <div className="flex justify-between items-center">
                <div
                  className={`text-base ${
                    theme.palette.mode === "light"
                      ? "text-[#181821]"
                      : "text-white"
                  }`}
                >
                  Pooled {token0Name}:
                </div>
                <div className="flex justify-center items-center gap-1">
                  <span
                    className={`text-base ${
                      theme.palette.mode === "light"
                        ? "text-[#69696F]"
                        : "text-[#D6DAFC]"
                    }`}
                  >
                    {formatBalanceForPrice(removeToken0Liquidity)}
                  </span>
                  <img
                    src={tokenImageMap[token0Name]}
                    alt={token0Name}
                    className="h-5 w-5"
                  />
                </div>
              </div>
              <div className="flex justify-between items-center">
                <div
                  className={`text-base ${
                    theme.palette.mode === "light"
                      ? "text-[#181821]"
                      : "text-white"
                  }`}
                >
                  Pooled {token1Name}:
                </div>
                <div className="flex justify-center items-center gap-1">
                  <span
                    className={`text-base ${
                      theme.palette.mode === "light"
                        ? "text-[#69696F]"
                        : "text-[#D6DAFC]"
                    }`}
                  >
                    {formatBalanceForPrice(removeToken1Liquidity)}
                  </span>
                  <img
                    src={tokenImageMap[token1Name]}
                    alt={token1Name}
                    className="h-5 w-5"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {walletAddress ? (
        <button
          className={`w-full py-3 px-6 z-10 rounded-[12px] text-base font-semibold leading-6 text-white bg-[#5763F3] hover:bg-[rgb(116,127,244)] transition-colors duration-300`}
          onClick={() =>
            removeLiquiditynew(
              Number(removeToken0Liquidity),
              Number(removeToken1Liquidity),
              token0Name,
              token1Name,
              Number(nftId),
              jsonRpcProvider,
              setIsConfirmModalOpen,
              setIsRemoveConfirmed,
              setIsTransactionFailed,
              setError,
              setHashdata,
              setIsLiquidityChanged,
              setRemoveLiquidity,
							walletAddress
            )
          }
          disabled={
            !selectedOption ||
            !removeLiquidityValue ||
            !removeToken0Liquidity ||
            !removeToken1Liquidity
          }
        >
          {selectedOption ? "Remove Liquidity" : "Select NFT ID"}
        </button>
      ) : (
        <NavLink
          to="/connect-wallet"
          className="w-full h-[47px] min-h-[47px] rounded-[12px] flex items-center justify-center bg-[#5763F3] hover:bg-[rgb(116,127,244)] transition-colors duration-300  text-white cursor-pointer z-10"
        >
          Connect Wallet
        </NavLink>
      )}
      {isConfirmModalOpen && (
        <LiquidityConfirmationModal
          onClose={() => setIsConfirmModalOpen(false)}
          text={`Removing ${formatBalanceForPrice(
            removeToken0Liquidity
          )} ${token0Name} and ${formatBalanceForPrice(
            removeToken1Liquidity
          )} ${token1Name}`}
        />
      )}
      {isRemoveConfirmed && (
        <LiquidityConfirmedModal
          onClose={() => setIsRemoveConfirmed(false)}
          text={`Removed Liquidity`}
          paragraph={`${formatBalanceForPrice(
            removeToken0Liquidity
          )} ${token0Name} and ${formatBalanceForPrice(
            removeToken1Liquidity
          )} ${token1Name}`}
          token0Name={token0Name}
          token1Name={token1Name}
          hashdata={hashdata}
        />
      )}
      {isTransactionFailed && (
        <FailedTransaction
          onClose={() => setIsTransactionFailed(false)}
          error={error}
        />
      )}
    </div>
  );
};

export default RemoveLiquidity;
